<template>
	<div class="status-container">
		<div class="tweetStatus" v-for="item in getStatus" :key="item.id">
			<el-button size="small" @click="item.event">{{ item.text }}</el-button>
		</div>

		<div class="tweetStatus" v-if="showButton">
			<el-button size="small" @click="tableData.remove(scope.row)">删除</el-button>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {
			groupList: {
				1: [
					{
						text: '查看推文',
						event: () => this.tableData.watchTweets(this.scope.row),
					},
				],
				2: [
					{
						text: '更改时间',
						event: () => this.tableData.changeTime(this.scope.row),
					},
					{
						text: '立即发布',
						event: () => this.tableData.publish(this.scope.row),
					},
				],
				3: [
					{
						text: '重试',
						event: () => this.tableData.retry(this.scope.row),
					},
				],
			},
		};
	},
	computed: {
		getStatus() {
			let res = null;
			Object.keys(this.groupList).map(item => {
				if (item == this.scope.row.status) {
					res = this.groupList[item];
				}
			});
			return res;
		},
		showButton() {
			return (
				this.getPermission(this.$permissionData.tweetsDelete.englishName) &&
				this.tableData.showStatus(this.scope.row)
			);
		},
	},
	watch: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
.status-container {
	display: flex;

	.tweetStatus {
		margin-right: 5px;
	}
}
</style>
